/* global fetch */

import { config } from '../config';
import { headers, APIResponse, stleaf, fetchAPI, SpanTag } from '../helpers';

export const create = (st: SpanTag, obj) => {
  const url = new URL(`${config.API_URL}/v1/job`);
  return fetchAPI(stleaf(st, 'yei7ie'), url.toString(), {
    method: 'POST',
    credentials: 'include',
    headers,
    body: JSON.stringify(obj),
  });
};

export const updateCaptureRequest = (
  st: SpanTag,
  id: string,
  fieldsToUpdate,
): Promise<APIResponse> => {
  const url = new URL(`${config.API_URL}/v2/jobs/${id}`);
  return fetchAPI(stleaf(st, 'ohs3bu'), url, {
    method: 'PUT',
    credentials: 'include',
    headers,
    body: JSON.stringify(fieldsToUpdate),
  });
};
